import React, { createContext, useContext, ReactNode, useState, useEffect } from "react";
import Neko from "../components/Core/Neko";
import { useApp } from "./AppContext";

export interface NekoContextType {
  enabled: boolean;
  setEnabled: (v: boolean) => void;
  // setSleepPos: (x: number, y: number) => void;
}

const NekoContext = createContext<NekoContextType | undefined>(undefined);
export const useNeko = () => {
  const ctx = useContext(NekoContext);
  if (!ctx) throw new Error("useNeko must be used inside NekoProvider");
  return ctx;
};

export default function NekoProvider({ children }: { children: ReactNode }) {
  // hardcoded start/sleep position (server authoritative in this app)
  const startX = 10;
  const startY =
    typeof window !== "undefined" ? (window.innerHeight || 400) - 32 - 50 : 400 - 32 - 50;

  const [enabled, setEnabled] = useState<boolean>(false); // hidden by default, will be enabled on quest completion
  const [sleepX, setSleepX] = useState<number | null>(startX);
  const [sleepY, setSleepY] = useState<number | null>(startY);

  // const setSleepPos = (x: number, y: number) => {
  //   setSleepX(x);
  //   setSleepY(y);
  // };

  // listen for quest list messages and enable neko when `find_catsi` completes
  const app = useApp();

  useEffect(() => {
    if (!app || !app.onMessage) return;

    const unsub = app.onMessage("quest_list", (message: any) => {
      try {
        if (
          message &&
          message.service === "quest" &&
          message.payload &&
          Array.isArray(message.payload.quests)
        ) {
          const quests = message.payload.quests;
          // support both legacy `find_catsi` and `unlock_cats` quest ids
          const found = quests.find(
            (q: any) =>
              (q.id === "find_catsi" || q.id === "unlock_cats") && q.status === "completed",
          );
          if (found) setEnabled(true);
        }
      } catch (err) {
        console.error("Neko: failed to process quest_list message", err);
      }
    });

    return () => {
      if (unsub) unsub();
    };
  }, [app]);

  // request initial quest list when session is ready so we can auto-enable neko if quest already completed
  useEffect(() => {
    if (!app || !app.sessionReady) return;
    app.sendMessage("quest", "get_quests", {});
  }, [app, app.sessionReady]);

  const value: NekoContextType = {
    enabled,
    setEnabled,
    // setSleepPos,
  };

  return (
    <NekoContext.Provider value={value}>
      <Neko enabled={enabled} sleepX={sleepX} sleepY={sleepY} setEnabled={setEnabled} />
      {children}
    </NekoContext.Provider>
  );
}
